<template>
  <div id="loading-items">
    <div class="loading-items-container" :style="`height: ${height}px`">
      <div class="loading-items-container__inner">
        <div
          v-for="item in items"
          :key="item.id"
          :class="circle ? 'loading-items-container__inner__item transparent' : 'loading-items-container__inner__item color-change-2x'"
        >
          <div v-if="circle" class="circle color-change-2x" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoadingItems',
  props: {
    items: {
      type: Number,
      required: false,
      default: 4
    },
    height: {
      type: Number,
      rewuired: false,
      default: 385
    },
    circle: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/ui/_loading-items.scss';
</style>
